import User from "./user";
import VuexState from "./vuex-state";

const vuexState = new VuexState();
const userSession = new User();

export { vuexState, userSession };
